export default __webpack_public_path__ + "c0a5ae94a18570e64e02d90541361b5b.jpg";